import React from 'react';
import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';
import WorkflowStageFilter from 'components/ReactTable/Filters/WorkflowStageFilter';
import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const workflowColumnDefs = (permissions, classNameInitialReview, classNameWorkflow) => [
  {
    Header: 'Customer',
    accessor: 'customer',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<CustomerLinkCell dataKey="customerDbId" data={ original } permissions={ permissions } />);
    },
    className: classNameInitialReview,
  },
  {
    Header: 'Form Type',
    accessor: 'formTypeDescription',
    Filter: MultiSelectFilter,
    className: classNameInitialReview,
  },
  {
    Header: 'Source',
    accessor: 'formSourceDescription',
    Filter: MultiSelectFilter,
    className: classNameInitialReview,
  },
  {
    Header: 'Workflow',
    accessor: 'workflowStageDescription',
    Filter: WorkflowStageFilter,
    className: classNameWorkflow
  },
  {
    Header: 'Last Action',
    accessor: 'lastActionDate',
    disableFilters: true,
    className: classNameInitialReview,
  },
  {
    Header: 'Uploaded By',
    accessor: 'uploadedBy',
    disableSortBy: true,
    className: 'col-15p'
  },
  {
    Header: 'Initial Review By',
    accessor: 'workflowPreviousUsername',
    disableSortBy: true,
    isVisible: false,
    className: 'col-15p'
  },
  {
    Header: 'Assigned To',
    accessor: 'workflowUsername',
    disableSortBy: true,
    isVisible: false,
    className: 'col-15p'
  },
  {
    Header: 'Item Id',
    accessor: 'itemId',
    isVisible: false
  },
  {
    Header: 'Form Type Description',
    accessor: 'formTypeString',
    isVisible: false
  },
  {
    Header: 'Workflow Stage',
    accessor: 'workflowStage',
    isVisible: false
  }
];

export default workflowColumnDefs;
